var _defs, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxTrailer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 197.1 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #3b66b0;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.1,68.3h-13.3c-.9,0-1.4-.4-2.1-.9-1.9-1.4-2.5-3.3-2.3-5.7.2-2.2,0-4.6,0-6.8s.2-.9.9-.9h27.6c.6,0,1,.3,1.5.6,2,1.5,3,3.5,2.6,6.2-.2,2,0,4.3,0,6.3s-.3,1.2-1.2,1.2c0,0-13.7,0-13.7,0ZM103,64.2h10.9c.9,0,1.1-.3,1-1.1v-3.6c0-1-.5-1.5-1.5-1.5h-22.1c-.6,0-.8.2-.8.8v3.6c0,1.2.5,1.7,1.7,1.7h10.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.8,52c5.7,0,10.3,4.6,10.2,10.2,0,5.6-4.6,10.2-10.2,10.2s-10.2-4.6-10.2-10.2,4.6-10.1,10.2-10.2ZM29.8,68.2c3.4,0,6.1-2.8,6.1-6.1s-2.8-6-6-6.1c-3.4,0-6.1,2.6-6.1,6s2.6,6.2,6,6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.2,52c5.6,0,10.2,4.5,10.2,10s-4.4,10.4-10.1,10.4-10.2-4.5-10.2-10.2,4.5-10.2,10.1-10.2ZM80.3,62.1c0-3.4-2.6-6-6-6.1-3.4,0-6.1,2.6-6.1,6.1s2.6,6.1,6.1,6.1,6-2.6,6-6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.2,52c5.6,0,10.2,4.5,10.2,10s-4.4,10.4-10.1,10.4-10.2-4.5-10.2-10.2,4.5-10.2,10.1-10.2ZM58.3,62.1c0-3.4-2.6-6-6-6.1-3.4,0-6.1,2.6-6.1,6.1s2.6,6.1,6.1,6.1,6-2.6,6-6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.1,66.2c-3.2,0-4.9-.8-6.2-2.6-.3-.4-.5-.7-.5-1.3v-7.4c0-.7.2-.9.9-.9h7.4c1.1,0,1.8-.3,1.8-1.5s.2-.5.6-.5h1.3c.7,0,1.6-.4,2.1.3s-.2,2.6-.8,3.5c-1.5,2-3.5,2.8-5.9,2.4h-2.9c-1,0-.7.2-.7.7v1.6c0,1.3.4,1.7,1.7,1.7h7.5c.7,0,.9.2.9.9,0,2.1-1,3.3-3.2,3.3h-4.4.1Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M190.7,6.2c.4,0,.8.4.8.8v38.3c0,.4-.4.8-.8.8H6.8c-.4,0-.8-.4-.8-.8V6.9c0-.4.4-.8.8-.8h183.9M190.7,2.2H6.8c-2.6,0-4.8,2.1-4.8,4.8v38.3c0,2.6,2.1,4.8,4.8,4.8h183.9c2.6,0,4.8-2.1,4.8-4.8V6.9c0-2.6-2.1-4.8-4.8-4.8h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxTrailer);
export default __webpack_public_path__ + "static/media/box-trailer.038c2695559fd348d2c366c21a2dca02.svg";
export { ForwardRef as ReactComponent };